import styled from 'styled-components';

import { colors } from 'common/styles/style-constants';

import { StyledInput } from '../../../legacy-checkout/checkout-styled-components';

export const FloatingStyledInput = styled(StyledInput)`
  && {
    font-size: 16px;
    font-weight: 600;
    color: ${colors.gray9};
    height: auto;
    padding: 24px 12px 10px;
    word-break: normal;
  }
`;

export const FloatingStyledTextarea = styled.textarea`
  font-size: 16px;
  font-weight: 600;
  color: ${colors.gray9};
  padding: 24px 12px 10px;
  width: 100%;
  min-height: 60px;
  height: ${(props) => props.height || '140px'};
  border: 1px solid ${(props) => (props.error === 'true' ? 'red' : colors.gray6)};
  border-radius: 10px;
  box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.1);

  &::placeholder {
    color: ${colors.gray8};
  }

  &:active,
  &:focus {
    border-color: ${colors.blue};
    box-shadow: 0 0 3px ${colors.blue};
  }

  &:hover {
    border-color: ${colors.blue};
    box-shadow: inset 0px 2px 3px rgba(0, 0, 0, 0.05);
  }
`;

export const HoldFloat = styled.div`
  position: relative;
  overflow: hidden;
`;

export const Label = styled.label`
  && {
    color: ${colors.gray8};
    font-weight: 400;
    position: absolute;
    top: 18px;
    left: 12px;
    font-size: 16px;
    transition: transform 0.3s ease-in-out;
    background: 0;
    border: 0;
    outline: none;
    padding: 0;
    margin: 0;
    transform: ${(props) =>
    (props.small ? 'scale(0.8) translateX(-12%) translateY(-60%)' : 'none')};
  }
`;
